import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ConfigProvider from '../../config-provider';
import { obj } from '../../util';

import Icon from '../../icon';

/**
 * Button.Icon
 */
class IconButton extends Component {
  static propTypes = {
    prefix: PropTypes.string,
    /**
     * 图标按钮的图标名字
     */
    name: PropTypes.string,
    /**
     * 图标按钮的图标类型
     */
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    /**
     * 当 component = 'button' 时，设置 button 标签的 type 值
     */
    htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),
    /**
     * 设置标签类型
     */
    component: PropTypes.oneOf(['button', 'a', 'div', 'span']),
    /**
     * 统一设置 Button 组件的按钮大小
     */
    size: PropTypes.oneOf(['medium', 'large']),
    /**
     * 图标按钮的图标颜色
     */
    color: PropTypes.oneOf(['default', 'gray']),
    /**
     * 是否禁用
     */
    disabled: PropTypes.bool,
    /**
     * 点击按钮的回调
     * @param {Object} e Event Object
     */
    onClick: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
    htmlType: 'button',
    component: 'button',
    type: 'primary',
    color: 'default',
    disabled: false,
    onClick: () => {},
  };

  onClick = (e) => {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    this.props.onClick(e);
  };

  render() {
    const { prefix, className, size, htmlType, component, type, name, color, disabled, children } = this.props;

    const groupCls = classNames(`${prefix}iconbtn`, {
      [`${prefix}iconbtn-${type}`]: type,
      [`${prefix}iconbtn-${size}`]: size,
      [`${prefix}iconbtn-${color}`]: color,
      disabled,
      [className]: className,
    });

    const TagName = component;
    const tagAttrs = {
      ...this.props,
      type: htmlType,
      className: groupCls,
    };

    if (TagName !== 'button') {
      delete tagAttrs.type;
    }

    return (
      <TagName {...obj.pickAttrs(tagAttrs)} onClick={this.onClick}>
        {name ? <Icon type={name} size={size} /> : children}
      </TagName>
    );
  }
}

export default ConfigProvider.config(IconButton);
